/*
 * @Author: hfxie
 * @Date: 2022-02-21 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 17:15:41
 * @Description: 常量名
 */

const PLANS = "pageData";// "plans"; // 拖拽目标容器类型 默认的 主容器

const TODOS = "todo"; // 待分配容器
const EMPTY_ID_TODO = "emptyIdTodo"; // 空的待分配区块ID
const EMPTY_NAME_TODO = "emptyNameTodo"; // 空的待分配区块ID
const SUMMARY = "summary"; // 统计区


const DEFAULT_HIGHLIGHT_TYPE = "DEFAULTHIGH"; // 默认的高亮后端值

const VIRTUAL_START_NUM = 800; // 虚拟列表启用阈值数量


/* 图标列表 */
const ICON_LIST = [
  // "el-icon-s-flag", // 旗子-项目 0
  "el-icon-folder", // 项目
  // "el-icon-folder-opened", // 文件夹-汇总 1
  "el-icon-date", // wbs
  "el-icon-star-on", // 实心星星-里程碑任务 2
  "el-icon-star-off", // 空心星星-重要任务 3
  "el-icon-warning", // 实心感叹号-高风险任务 4
  "el-icon-warning-outline", // 空心感叹号-低风险任务
  "el-icon-paperclip", // 回形针-普通任务(资源图标 6)
  "el-icon-document", // 书本-普通任务(任务这边普通不设图标为 -1)


  "el-icon-sunrise-1", // 早班
  "el-icon-sunny", // 午班
  "el-icon-moon", // 晚班

  /* 苍穹图标 11 - 16 */
  "kdfont kdfont-xiangmu15", // 项目
  "kdfont kdfont-zuzhi12", // 组织
  "kdfont kdfont-wenjianjia5", // 文件夹
  "kdfont kdfont-gongzuodigao2", // 工作底稿
  "kdfont kdfont-qi128", // 旗
  "kdfont kdfont-shuqian", // 书签 iconcool

  "el-icon-message-solid", // 三色灯
  "el-icon-message-solid", // 三色灯
  "el-icon-message-solid", // 三色灯
  "el-icon-document", // 任务
  "el-icon-document",
  // 新增的自定义选择图标下标从22-132
  "el-icon-delete",
  "el-icon-s-tools",
  "el-icon-setting",
  "el-icon-user-solid",
  "el-icon-user",
  "el-icon-phone",
  "el-icon-phone-outline",
  "el-icon-more",
  "el-icon-more-outline",
  "el-icon-star-on",
  "el-icon-star-off",
  "el-icon-warning",
  "el-icon-warning-outline",
  "el-icon-question",
  "el-icon-remove",
  "el-icon-circle-plus",
  "el-icon-success",
  "el-icon-error",
  "el-icon-zoom-in",
  "el-icon-zoom-out",
  "el-icon-remove-outline",
  "el-icon-circle-plus-outline",
  "el-icon-circle-check",
  "el-icon-circle-close",
  "el-icon-s-help",
  "el-icon-help",
  "el-icon-minus",
  "el-icon-plus",
  "el-icon-check",
  "el-icon-close",
  "el-icon-upload",
  "el-icon-message-solid",
  "el-icon-bell",
  "el-icon-s-platform",
  "el-icon-s-fold",
  "el-icon-s-unfold",
  "el-icon-s-operation",
  "el-icon-s-home",
  "el-icon-s-flag",
  "el-icon-s-comment",
  "el-icon-s-custom",
  "el-icon-s-opportunity",
  "el-icon-s-data",
  "el-icon-s-grid",
  "el-icon-menu",
  "el-icon-share",
  "el-icon-d-caret",
  "el-icon-caret-left",
  "el-icon-caret-right",
  "el-icon-caret-bottom",
  "el-icon-caret-top",
  "el-icon-bottom-left",
  "el-icon-bottom-right",
  "el-icon-back",
  "el-icon-right",
  "el-icon-bottom",
  "el-icon-top",
  "el-icon-top-left",
  "el-icon-top-right",
  "el-icon-arrow-left",
  "el-icon-arrow-right",
  "el-icon-arrow-down",
  "el-icon-arrow-up",
  "el-icon-d-arrow-left",
  "el-icon-d-arrow-right",
  "el-icon-refresh",
  "el-icon-refresh-right",
  "el-icon-view",
  "el-icon-date",
  "el-icon-edit",
  "el-icon-edit-outline",
  "el-icon-folder",
  "el-icon-folder-opened",
  "el-icon-folder-add",
  "el-icon-folder-remove",
  "el-icon-folder-delete",
  "el-icon-folder-checked",
  "el-icon-tickets",
  "el-icon-document-remove",
  "el-icon-document-delete",
  "el-icon-document-copy",
  "el-icon-document-checked",
  "el-icon-document",
  "el-icon-document-add",
  "el-icon-printer",
  "el-icon-search",
  "el-icon-monitor",
  "el-icon-collection-tag",
  "el-icon-suitcase",
  "el-icon-suitcase-1",
  "el-icon-notebook-1",
  "el-icon-notebook-2",
  "el-icon-shopping-cart-1",
  "el-icon-shopping-cart-2",
  "el-icon-present",
  "el-icon-discount",
  "el-icon-price-tag",
  "el-icon-thumb",
  "el-icon-open",
  "el-icon-turn-off",
  "el-icon-chat-round",
  "el-icon-chat-line-round",
  "el-icon-chat-square",
  "el-icon-chat-dot-round",
  "el-icon-message",
  "el-icon-time",
  "el-icon-odometer",
  "el-icon-location",
  "el-icon-location-outline",
  "el-icon-unlock",
  "el-icon-wind-power",


];


const CONSTNAME = {
  PLANS,
  TODOS,
  EMPTY_ID_TODO,
  EMPTY_NAME_TODO,
  DEFAULT_HIGHLIGHT_TYPE,
  VIRTUAL_START_NUM,
  ICON_LIST,
  SUMMARY,
};

export default CONSTNAME;
